import { all, call, fork, put, select } from 'redux-saga/effects';
import keyBy from 'lodash.keyby';
import { AxiosResponse, AxiosError } from 'axios';

// Global Types
import { SagaIterator } from 'redux-saga';

// Global Utils
// @ts-ignore
import axiosPoll from 'utils/axiosPoll';
import { takeLatestWithCancel } from 'utils/redux-saga';

// Local Types
import { HarvestEventDocumentsLoadRequestedAction } from './types';

// Local Actions
import {
    succeededLoadHarvestEventDocuments,
    failedLoadHarvestEventDocuments,
    setHarvestEventDocuments
} from './actions';

// Local Selectors
import { selectHarvestEventDocumentsLoadParams } from './params';

// Local Constants
import {
    HARVEST_EVENT_DOCUMENTS_LOAD_REQUESTED,
    HARVEST_EVENT_DOCUMENTS_LOAD_CANCELED
} from './constants';

// Environment
const { REACT_APP_API_URL } = process.env;

export function* loadHarvestEventDocumentsSucceeded(
    response: AxiosResponse
): SagaIterator {
    const { data } = response;

    const harvestEventDocumentsKeyedByUuid = keyBy(data, 'uuid');

    yield put(setHarvestEventDocuments(harvestEventDocumentsKeyedByUuid));

    yield put(succeededLoadHarvestEventDocuments(response));
}

export function* loadHarvestEventDocumentsFailed(
    error: AxiosError
): SagaIterator {
    yield put(failedLoadHarvestEventDocuments(error));
}

export function* loadHarvestEventDocuments(
    action: HarvestEventDocumentsLoadRequestedAction
): SagaIterator {
    const { entityId } = action.payload;
    const params = yield select(selectHarvestEventDocumentsLoadParams, {
        entityId
    });

    // TODO: create polling saga that polls for changes sence a given date stamp.
    if (params) {
        yield call(axiosPoll, {
            config: {
                method: 'GET',
                // Use #harvest to namespace hash storage
                url: `${REACT_APP_API_URL}/v1/Documents#harvest`,
                params
            },
            succeeded: loadHarvestEventDocumentsSucceeded,
            failed: loadHarvestEventDocumentsFailed
        });
    }
}

export function* watchHarvestEventDocumentsLoadRequested(): SagaIterator {
    yield takeLatestWithCancel(
        HARVEST_EVENT_DOCUMENTS_LOAD_REQUESTED,
        HARVEST_EVENT_DOCUMENTS_LOAD_CANCELED,
        loadHarvestEventDocuments
    );
}

export default function* harvestEventDocumentsSagas(): SagaIterator {
    yield all([fork(watchHarvestEventDocumentsLoadRequested)]);
}
